import { Form, Select, type SelectProps } from "antd";
import React, { useMemo } from "react";
import { type Rule } from "antd/es/form";
import { type FilterFunc } from "rc-select/lib/Select";
import { type DefaultOptionType } from "antd/es/cascader";
import { type Status } from "../../generated-axios-client";
import type { IntlShape } from "@formatjs/intl";

const statusSelectOptions = (statusItems: Status[]) => {
  const statusOptions = statusItems.map((item) => ({
    key: item.value,
    value: item.value,
    label: item.label,
  }));

  return statusOptions;
};

const statusSearchHandler: FilterFunc<DefaultOptionType> = (input, option) => {
  const search = input.toLowerCase();
  const value = option?.label?.toString().toLowerCase?.() ?? "";

  return value.includes(search);
};

type StatusSelectFormItemProps = {
  intl: IntlShape;
  statusItems: Status[];
  rules?: Rule[];
  placeholder?: string | boolean;
  selectProps?: SelectProps<string>;
};

export const StatusSelectorFormItem = (props: StatusSelectFormItemProps) => {
  const { intl, statusItems, rules = [], placeholder = false, selectProps } = props;

  const options = useMemo(() => statusSelectOptions(statusItems), [statusItems]);

  return (
    <Form.Item
      name="status"
      label={intl.formatMessage({ id: "filter_label_status" })}
      rules={rules}
    >
      <Select
        placeholder={placeholder}
        showSearch={true}
        options={options}
        filterOption={statusSearchHandler}
        {...selectProps}
      />
    </Form.Item>
  );
};
